import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Risks from "@/pages/Risks";
import RiskDetail from "@/pages/RiskDetail";
import Findings from "@/pages/Findings";
import Appetite from "@/pages/Appetite";
import Acceptances from "@/pages/Acceptances";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Audit from "@/pages/Audit";
import Settings from "@/pages/Settings";
import Tenants from "@/pages/Tenants";
import Portfolio from "@/pages/Portfolio";
import Invite from "@/pages/Invite";
import Trust from "@/pages/Trust";
import Landing from "@/pages/Landing";
import Profile from "@/pages/Profile";
import HowToUse from "@/pages/HowToUse";
import Changelog from "@/pages/Changelog";
import AdvisorNotes from "@/pages/AdvisorNotes";
import Projects from "@/pages/Projects";
import Assessments from "@/pages/Assessments";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Roadmap from "@/pages/Roadmap";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center bg-[#FBFBF9]"><div className="text-slate-500 font-mono text-xs">Loading…</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function Shell() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/about" element={<About />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/trust" element={<Trust />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/changelog" element={<Changelog />} />
      <Route path="/invite/:token" element={<Invite />} />
      <Route path="/tenants" element={<Protected><Tenants /></Protected>} />
      <Route path="/portfolio" element={<Protected><Portfolio /></Protected>} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/risks" element={<Protected><Risks /></Protected>} />
      <Route path="/risks/:id" element={<Protected><RiskDetail /></Protected>} />
      <Route path="/findings" element={<Protected><Findings /></Protected>} />
      <Route path="/appetite" element={<Protected><Appetite /></Protected>} />
      <Route path="/acceptances" element={<Protected><Acceptances /></Protected>} />
      <Route path="/reports" element={<Protected><Reports /></Protected>} />
      <Route path="/advisor" element={<Protected><AdvisorNotes /></Protected>} />
      <Route path="/projects" element={<Protected><Projects /></Protected>} />
      <Route path="/assessments" element={<Protected><Assessments /></Protected>} />
      <Route path="/users" element={<Protected><Users /></Protected>} />
      <Route path="/audit" element={<Protected><Audit /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="/how-to-use" element={<Protected><HowToUse /></Protected>} />
      <Route path="/roadmap" element={<Protected><Roadmap /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Shell />
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
